import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronDown } from "../../../assets/arrowDown.svg";
import { useStyles } from "./OrderHistoryFilter.styles";

export type OrdersHistoryFilterValue =
  | "last3months"
  | "last6months"
  | "last12months"
  | "all";

interface Props {
  value: OrdersHistoryFilterValue;
  onChange: (value: OrdersHistoryFilterValue) => void;
}

const OrdersHistoryFilter: React.FC<Props> = ({ value, onChange }) => {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const classes = useStyles();

  const labels = {
    last3months: t("account.last3months"),
    last6months: t("account.last6months"),
    last12months: t("account.last12months"),
    all: t("account.allTime"),
  };

  return (
    <div className={classes.wrapper}>
      <button className={classes.button} onClick={() => setOpen((p) => !p)}>
        {labels[value]}
        <ChevronDown className={classes.icon} />
      </button>

      {open && (
        <div className={classes.dropdown}>
          {(
            [
              "last3months",
              "last6months",
              "last12months",
              "all",
            ] as OrdersHistoryFilterValue[]
          ).map((key) => {
            const isSelected = key === value;

            return (
              <div
                key={key}
                className={
                  isSelected
                    ? `${classes.item} ${classes.itemDisabled}`
                    : classes.item
                }
                onClick={() => {
                  if (!isSelected) {
                    onChange(key);
                    setOpen(false);
                  }
                }}
              >
                {labels[key]}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default OrdersHistoryFilter;
